import type { StorageApi } from '@/lib/api';

/**
 * Configuration for a storage arche's frontend UI.
 * Passed to shared storage components to customize behavior per arche.
 */
export interface StorageArcheConfig {
  /** Display title (e.g. "DFE Avatars") */
  title: string;
  /** Role required to access the UI (e.g. "litcraft_admin") */
  requiredRole: string;
  /** Message shown when user lacks the required role */
  accessDeniedMessage: string;
  /** Query key namespace root (e.g. ['dfeAvatars']) */
  queryKeyNamespace: readonly string[];
  /** API methods for this storage arche */
  api: StorageApi;
  /** Accepted file types for the file input (e.g. "image/*" or ".bundle,.json,.hash") */
  acceptedFileTypes?: string;
}

/**
 * Query key factory for a storage arche, derived from the namespace.
 */
export interface StorageQueryKeys {
  all: readonly string[];
  groups: () => readonly string[];
  files: (prefix: string) => readonly string[];
}

export function createStorageQueryKeys(namespace: readonly string[]): StorageQueryKeys {
  return {
    all: namespace,
    groups: () => [...namespace, 'groups'],
    files: (prefix: string) => [...namespace, 'files', prefix],
  };
}
